import _sfc_main from "./component-library141.mjs";
import "./component-library142.mjs";
import normalizeComponent from "./component-library97.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("nav", { staticClass: "breadcrumb", class: _setup.containerClass, attrs: { "aria-label": "Du bist hier:" } }, [_c("ul", { staticClass: "breadcrumb__list" }, _vm._l(_setup.fullItems, function(item, index) {
    return _c("li", { key: index, staticClass: "breadcrumb__element" }, [item.to ? _c(_setup.LinkButton, { staticClass: "breadcrumb__link", class: { "breadcrumb__link--is-active": _setup.isActive(index) }, attrs: { "tealium-type": "context.text.breadcrumb", "to": item.to, "tag": "nuxt-link", "exact": "", "label": item.label, "no-styling": "" } }) : _c("span", { staticClass: "breadcrumb__link", class: { "breadcrumb__link--is-active": _setup.isActive(index) } }, [_vm._v(" " + _vm._s(item.label) + " ")]), !_setup.isActive(index) ? _c("span", { staticClass: "breadcrumb__element-separator", attrs: { "aria-hidden": "true" } }, [_vm._v("·")]) : _vm._e()], 1);
  }), 0), _vm.withBrodos ? _c("span", { staticClass: "breadcrumb__element breadcrumb__brodos-claim" }, [_vm._v(" In Kooperation mit "), _c(_setup.BrodosLogo, { staticClass: "breadcrumb__brodos-claim-logo", attrs: { "height": 12, "width": 51 } })], 1) : _vm._e(), _c("script", { attrs: { "type": "application/ld+json" } }, [_vm._v(" " + _vm._s(_setup.jsonLD) + " ")])]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "7f6f8fbf",
  null,
  null
);
const breadcrumb = __component__.exports;
export {
  breadcrumb as default
};
